// @ts-nocheck
// Feature Flags Configuration
// CARDEX Phase 1: Local Trading Community

export const FEATURES = {
  // Trading features (Phase 1 - LIVE)
  TRADING_ENABLED: true,
  
  // Marketplace features (Phase 2 - LOCKED)
  MARKETPLACE_ENABLED: false,
  
  // Events/Conventions (Future - LOCKED)
  EVENTS_ENABLED: true,
  
  // Region restrictions for marketplace (when enabled)
  MARKETPLACE_ALLOWED_COUNTRIES: ["US"],
};

// Helper function to check if marketplace is accessible
export const isMarketplaceAllowed = () => {
  return FEATURES.MARKETPLACE_ENABLED;
};

// Helper function to check if events are accessible
export const areEventsAllowed = () => {
  return FEATURES.EVENTS_ENABLED;
};

// Helper function to check if trading is accessible
export const isTradingAllowed = () => {
  return FEATURES.TRADING_ENABLED;
};
